

























































import Vue from 'vue'
import mixins from 'vue-typed-mixins'
import Pagination from '@morpheus/utils/admin-vue/mixins/pagination'
import ShopsList from '../components/ShopsList.vue'
import { copyShop, fetchShopsList } from '../services/shops-client'
import { ShopsListData, ShopsListItemData } from '../types'

export default mixins(Pagination).extend({
  name: 'Shops',
  components: {
    ShopsList
  },
  mixins: [Pagination],
  data () {
    return {
      isLoading: true,
      headers: [
        { text: 'Code', value: 'code', sortable: false },
        { text: 'Enabled', value: 'enabled', sortable: false },
        { text: 'Listings total', value: 'listings_total', sortable: false },
        { text: 'Updated At', value: 'updated_at', sortable: false },
        { text: 'Created At', value: 'created_at', sortable: false },
        { text: 'Actions', value: '_id', align: 'right', sortable: false }
      ],
      itemsList: []
    }
  },
  mounted () {
    this.$store.commit('global/setLoading', true)
    this.fetchItems()
  },
  methods: {
    fetchItems () {
      this.isLoading = true
      fetchShopsList(`?limit=${this.rowsPerPage}&offset=${this.paginationOffset}`)
        .then(({ items, total }: ShopsListData) => {
          this.itemsList.splice(0, this.itemsTotal)
          items.forEach((item: ShopsListItemData, index: number) => {
            Vue.set(this.itemsList, index, item)
          })
          this.itemsTotal = total
        })
        .catch(error => {
          this.$store.commit('global/addNotification', { text: error.error, type: 'error' })
        })
        .finally(() => {
          this.checkPagination()
          this.$store.commit('global/setLoading', false)
          this.isLoading = false
        })
    },
    onCopyShop (shopId: string, shopCode: string) {
      this.$store.commit('global/setLoading', true)
      const shop = {
        code: shopCode
      }
      copyShop(shopId, shop)
        .then(() => {
          this.$store.commit('global/addNotification', {
            text: 'You successfully copied shop!',
            type: 'success'
          })
          this.fetchItems()
        })
        .catch(error => {
          this.$store.commit('global/addNotification', { text: error.error, type: 'error' })
        })
        .finally(() => {
          this.$store.commit('global/setLoading', false)
        })
    }
  }
})
